import { createSelector } from 'reselect';
import { getState } from './utils';

const getFetches = createSelector(getState, state => state.fetches);

const getBuyerFieldFetches = createSelector(getFetches, fetches => fetches.formFields);
const getProfileFetches = createSelector(getFetches, fetches => fetches.profile);

export {
  getBuyerFieldFetches,
  getProfileFetches,
};
